<template>
  <a @click="addPaymentMethod" class="payment-profile mb-2 mr-2" :data-test-id="`${dataTestId}__add-payment-method-card-link`">
    <v-icon>mdi-credit-card-outline</v-icon>
    <p class="font700 mt-2">Add Payment Method</p>
  </a>
</template>
<script>
export default {
  name: 'add-payment-method-card',
  props: {
    totalPaymentProfiles: {
      type: Number,
      default: 0
    },
    dataTestId: String
  },
  methods: {
    addPaymentMethod() {
      const maxAllowedPaymentProfiles = 10;
      if (this.totalPaymentProfiles < maxAllowedPaymentProfiles) {
        this.$emit('toggleAddPaymentProfile', true);
      } else {
        this.snackbar('info', this.$message.PAYMENT_METHOD_LIMIT_EXCEEDS);
      }
    }
  }
};
</script>
